const labels = {
  clearAllFilters: 'Reset/Clear all filters',
  close: 'Close',
  filterBarTitle: 'Filter <strong>Your Results:</strong>',
  moreFilters: 'More Filters',
  moreFiltersSubmit: 'Apply Filters'
}

export default labels
